export default __webpack_public_path__ + "static/media/no_data.03e5f84c.svg";